import script from "./DetailTop.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailTop.vue?vue&type=script&setup=true&lang=js"

import "./DetailTop.vue?vue&type=style&index=0&id=40a132a6&scoped=true&lang=css"

import exportComponent from "/home/jenkins/storybird-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40a132a6"]])

export default __exports__